import { render, staticRenderFns } from "./PeriodResults.vue?vue&type=template&id=fa72fb6e"
import script from "./PeriodResults.js?vue&type=script&lang=js&external"
export * from "./PeriodResults.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports